import React from "react";
import Card from "../components/Card";
import Button from "../components/Button";
import Icon, { IconName } from "../icons/Icon";

const stats: Array<{
  label: string;
  value: string;
  delta: string;
  icon: IconName;
}> = [
  {
    label: "Active Missions",
    value: "24",
    delta: "+4 today",
    icon: "Target",
  },
  {
    label: "Signals Monitored",
    value: "128",
    delta: "+12% week",
    icon: "Signal",
  },
  {
    label: "Operators Online",
    value: "19",
    delta: "Stable",
    icon: "Users",
  },
  {
    label: "Risk Alerts",
    value: "3",
    delta: "-2 resolved",
    icon: "AlertTriangle",
  },
];

const activity: Array<{ title: string; time: string }> = [
  {
    title: "Briefing synced with regional command",
    time: "2 minutes ago",
  },
  {
    title: "New intel packet uploaded",
    time: "18 minutes ago",
  },
  {
    title: "Operator Delta completed checklist",
    time: "1 hour ago",
  },
];

const CommandCenter = () => {
  return (
    <div className="tw-flex tw-flex-col tw-gap-8">
      <section className="tw-flex tw-items-center tw-justify-between">
        <div>
          <p className="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-[0.2em] tw-text-rbah-ink/60">
            Overview
          </p>
          <h2 className="tw-text-3xl tw-font-bold tw-text-rbah-ink">
            Command Center
          </h2>
        </div>
        <div className="tw-flex tw-items-center tw-gap-3">
          <Button variant="ghost">
            <Icon name="Calendar" className="tw-h-4 tw-w-4 tw-text-rbah-ink" />
            Today
          </Button>
          <Button>
            <Icon name="Sparkles" className="tw-h-4 tw-w-4 tw-text-rbah-lime" />
            Generate Brief
          </Button>
        </div>
      </section>

      <section className="tw-grid tw-gap-6 lg:tw-grid-cols-4">
        {stats.map((stat) => (
          <Card key={stat.label} className="tw-p-6">
            <div className="tw-flex tw-items-center tw-justify-between">
              <div>
                <p className="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-[0.2em] tw-text-rbah-ink/60">
                  {stat.label}
                </p>
                <p className="tw-mt-2 tw-text-3xl tw-font-bold tw-text-rbah-ink">
                  {stat.value}
                </p>
              </div>
              <div className="tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-rbah tw-bg-rbah-ink">
                <Icon name={stat.icon} className="tw-h-5 tw-w-5 tw-text-rbah-lime" />
              </div>
            </div>
            <p className="tw-mt-4 tw-text-sm tw-font-semibold tw-text-rbah-ink/60">
              {stat.delta}
            </p>
          </Card>
        ))}
      </section>

      <section className="tw-grid tw-gap-6 lg:tw-grid-cols-3">
        <Card className="tw-p-6 lg:tw-col-span-2">
          <div className="tw-flex tw-items-center tw-justify-between">
            <div>
              <p className="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-[0.2em] tw-text-rbah-ink/60">
                Operations
              </p>
              <h3 className="tw-text-xl tw-font-bold tw-text-rbah-ink">
                Recent activity
              </h3>
            </div>
            <Icon name="Activity" className="tw-h-5 tw-w-5 tw-text-rbah-lime" />
          </div>
          <ul className="tw-mt-6 tw-flex tw-flex-col tw-gap-4">
            {activity.map((item) => (
              <li key={item.title} className="tw-flex tw-items-start tw-gap-3">
                <div className="tw-mt-1 tw-h-2.5 tw-w-2.5 tw-rounded-full tw-bg-rbah-lime" />
                <div>
                  <p className="tw-text-sm tw-font-semibold tw-text-rbah-ink">
                    {item.title}
                  </p>
                  <p className="tw-text-xs tw-font-semibold tw-text-rbah-ink/50">
                    {item.time}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </Card>

        <Card className="tw-flex tw-flex-col tw-gap-4 tw-p-6">
          <div className="tw-flex tw-items-center tw-justify-between">
            <div>
              <p className="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-[0.2em] tw-text-rbah-ink/60">
                Actions
              </p>
              <h3 className="tw-text-xl tw-font-bold tw-text-rbah-ink">
                Quick actions
              </h3>
            </div>
            <Icon name="Zap" className="tw-h-5 tw-w-5 tw-text-rbah-lime" />
          </div>
          <Button className="tw-w-full tw-justify-between">
            <span className="tw-flex tw-items-center tw-gap-2">
              <Icon name="Rocket" className="tw-h-4 tw-w-4 tw-text-rbah-lime" />
              Launch readiness check
            </span>
            <Icon name="ChevronRight" className="tw-h-4 tw-w-4 tw-text-rbah-off" />
          </Button>
          <Button variant="ghost" className="tw-w-full tw-justify-between">
            <span className="tw-flex tw-items-center tw-gap-2">
              <Icon name="FolderDown" className="tw-h-4 tw-w-4 tw-text-rbah-lime" />
              Sync intel drop
            </span>
            <Icon name="ChevronRight" className="tw-h-4 tw-w-4 tw-text-rbah-ink" />
          </Button>
          <Button variant="ghost" className="tw-w-full tw-justify-between">
            <span className="tw-flex tw-items-center tw-gap-2">
              <Icon name="Send" className="tw-h-4 tw-w-4 tw-text-rbah-lime" />
              Broadcast update
            </span>
            <Icon name="ChevronRight" className="tw-h-4 tw-w-4 tw-text-rbah-ink" />
          </Button>
        </Card>
      </section>
    </div>
  );
};

export default CommandCenter;
